import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RootObject, Year } from 'src/app/models/archive';
import { rootModel } from 'src/app/models/rootModel';
import { DataService } from 'src/app/Services/data.service';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.css']
})
export class ArchiveComponent implements OnInit {

  constructor(private dataservice:DataService,
    private router:Router,
    private route:ActivatedRoute) { }

  rootModel:rootModel = new rootModel();

  RootObject:RootObject = new RootObject();
  years: Year[];


  ngOnInit(): void {
   

    this.route.parent.paramMap.subscribe(params=>{



      this.rootModel.language  = params.get("language");  
    
      if(!this.rootModel.language)
      {     
        this.rootModel.language='tr';
      }

      console.log(this.rootModel);
       this.Makaleler(this.rootModel);      

    })

  }
  Makaleler(rootmodel)
  {
    this.dataservice.getMakale(rootmodel).subscribe(p=>{       

      console.log('makaleler ',p)

        this.years = p.sort((a, b) => a.publish_year - b.publish_year).
        sort((a, b) => a.jou_numbers[0].num_issue - b.jou_numbers[0].num_issue);
    })

  }  
  
  collapseId(deger:string,IsSharp:boolean)
  {
       if(IsSharp)
       return "#deger"+deger;

       else
       return "deger"+deger;       
  }

  showClass(index:number):string
  {
       if(index==0)
          return "show";          
  }
  
  activeClass(index:number):string
  {
       if(index==0)
          return "active";          
  }
  

}
